<style lang="sass">

    @import ../../common/styles/settings
    @import ../../common/styles/mixins

    .view-products

        margin-top: $baseline
        display: flex
        justify-content: center

        .card
            height: 100%
            text-align: center
            color: currentColor
            text-decoration: none

            .title
                margin: 0
            .text
                margin-bottom: $baseline
                text-transform: lowercase
                &:first-letter
                    text-transform: uppercase

            .card
                &__body
                    display: flex
                    flex-direction: column
                    height: inherit
                &__subtitle
                    margin-top: 0
                    margin-bottom: $baseline*.5

                &__icons
                    margin-top: 0

                    &__wrapper
                        display: flex
                        align-items: center
                        justify-content: center
                        margin-top: auto

                        +media(">small")
                            min-height: 6.25rem

            img
                max-height: $baseline*8

        > *
            margin-bottom: $baseline


</style>
<script>

    import Product from '../../common/components/Product.vue'

    export default {
        name: 'Products',
        components: {
            Product
        }
    }

</script>

